var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css.root},_vm._l((_vm.items),function(ref,key){
var icon = ref.icon;
var id = ref.id;
var link = ref.link;
var name = ref.name;
var title = ref.title;
return _c('a',{key:key,class:[_vm.css.link, _vm.css[id]],attrs:{"href":link,"target":"_blank","title":title}},[(icon)?_c(icon,{tag:"component"}):_c('span',[_vm._v(_vm._s(name))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }